import React, { useEffect, useRef, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { ImgURLSRC } from "../../../Url";
import HomeIcon from "@mui/icons-material/Home";
import { getSectionByID } from "../../Tools/Tools";
import SideBarButton from "../SideBar/SideBarButton";
import { ViewClass } from "../../Tools/Consts";
import { hasStartPageAtom } from "../../../../atoms";
import { useAtomValue, useSetAtom } from "jotai";
import { selectedSectionAtom, setSelectedSectionAtom } from "../../../../atoms";
import ContextMenu from "../ContextMenu";

export default function HiddenNav({ drawerOpen }) {
  const [visitedSectionsArr, setVisitedSectionsArr] = useState<[{ id: string; name: string | null; img: string }] | []>(
    [],
  );
  const contextMenuSelected = useRef<number | null>(null);
  const sideBarSelected = useAtomValue(selectedSectionAtom);
  const setSelectedSection = useSetAtom(setSelectedSectionAtom);
  const hasStartPage = useAtomValue(hasStartPageAtom);

  useEffect(() => {
    if (!sideBarSelected.ID || Number(sideBarSelected.ID) < 0) return;
    const key = visitedSectionsArr.findIndex((value) => value.id === sideBarSelected.ID);
    if (key !== -1) return;
    const newArr = [
      ...visitedSectionsArr,
      {
        id: sideBarSelected.ID,
        name: sideBarSelected.Title || sideBarSelected.Name || "",
        img: sideBarSelected.Image,
      },
    ];
    setVisitedSectionsArr(newArr);
  }, [sideBarSelected.ID]);

  const handleClickButton = (id: string) => {
    setSelectedSection(getSectionByID(id));
  };

  const handleContextMenu = () => {
    if (contextMenuSelected.current === null) return;
    const newArr = visitedSectionsArr.toSpliced(contextMenuSelected.current, 1, {
      ...visitedSectionsArr[contextMenuSelected.current],
      name: null,
    });
    setVisitedSectionsArr(newArr);
    contextMenuSelected.current = null;
  };

  return (
    <div id="HiddenNav" style={{ display: "inline-flex", marginLeft: "8px", height: "100%" }}>
      <SideBarButton style={{ display: drawerOpen ? "none" : "" }} />
      <Tooltip title={"Стартовая страница"} sx={{ display: hasStartPage ? "inline-flex" : "none" }}>
        <IconButton
          aria-label="CancelEdit"
          size="small"
          id={`MiniButton${sideBarSelected.ID}`}
          onClick={() => {
            setSelectedSection({
              ID: "-1",
              CLSID: ViewClass.HTMLView,
              Name: "Стартовая страница",
            });
          }}
        >
          <HomeIcon sx={{ fontSize: "1.25rem" }} />
        </IconButton>
      </Tooltip>
      <ContextMenu
        data={[
          {
            Caption: "Скрыть кнопку быстрого доступа",
            value: "hideButton",
          },
        ]}
        onMenuItemClick={handleContextMenu}
      >
        <div style={{ display: drawerOpen ? "none" : "inline-flex", height: "100%" }}>
          {visitedSectionsArr.map((value, index) => {
            if (value.name === null) return null;
            return (
              <Tooltip title={value.name} key={`mini-button_${value.id}`}>
                <IconButton
                  size="small"
                  id={`MiniButton${value.id}`}
                  onClick={() => {
                    handleClickButton(value.id);
                  }}
                  onContextMenu={() => {
                    contextMenuSelected.current = index;
                  }}
                >
                  <img alt="" style={{ height: "16px", width: "16px" }} src={ImgURLSRC(value.img)} />
                </IconButton>
              </Tooltip>
            );
          })}
        </div>
      </ContextMenu>
    </div>
  );
}
